module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/cobranca-tipo/cobranca-tipo.component.css
// module id = ./src/app/cobranca-tipo/cobranca-tipo.component.css
// module chunks = main